module.exports = __webpack_public_path__ + "static/media/shop-vip-divider-glows.c3f72eaf.png";